module.exports = "/_next/static/images/50d7b92844ad3fa0d832d40f95324ef7-rewards-hosting@3x.png.webp";